import ArticleFormContainer from './ArticleFormContainer';

export default ArticleFormContainer;
